<template>
    <content-view>
        <div slot="header">
            <a-form :form="form" layout="inline" @submit.prevent="handleSubmit">
                <a-form-item
                label="选择仓库"
                >
                    <a-select
                        v-decorator="['warehouseId']"
                        placeholder="请选择"
                        @change="changeStock"
                    >
                        <a-select-option
                        :value="item.id"
                        v-for="(item, index) in wareHouseList"
                        :key="index"
                        >{{item.name}}</a-select-option>
                    </a-select>
                </a-form-item>
                <a-form-item label="商品编号">
                    <a-input v-decorator="['serialNum']" placeholder="请输入" :disabled="disabled"></a-input>
                </a-form-item>
                <a-form-item label="商品名称">
                    <a-input v-decorator="['goodsName']" placeholder="请输入" :disabled="disabled"></a-input>
                </a-form-item>
                <a-form-item class="wrap-header-button">
                    <a-button class="mr8" type="primary" html-type="submit">筛选</a-button>
                    <a-button @click="handleReset">重置</a-button>
                </a-form-item>
            </a-form>
        </div>
        <div class="stock-taking">
            <!-- <p class="stock-taking_title">
                <a-icon
                    type="info-circle"
                    style="padding-right: 8px;color: #FFBF00;margin-top: 2px;"
                />盘点更新人：张三三
            </p> -->
            <a-table
                bordered
                :dataSource="dataSource"
                :columns="columns"
                :pagination="pagination"
                :rowKey="record => record.goodsId"
                @change="changePage"
            >
                <div slot="num" slot-scope="num,row">
                    <a-input-number :min="0" :precision="0" v-model="row.num" />
                </div>
            </a-table>
            <div class="mt16 text-center">
                <a-button @click="$router.go(-1)">返回</a-button>
                <a-button class="mr8" type="primary" @click="submit()">保存</a-button>
            </div>
        </div>
    </content-view>
</template>

<script type="text/javascript">
    import moment from 'moment';
    import { mapGetters } from "vuex";
    export default {
        name: 'stockTakingHistory',
        components: {},
        props: {},
        data() {
            const columns = [
                {
                    title: '商品编号',
                    dataIndex: 'serialNum'
                },
                {
                    title: '商品名称',
                    dataIndex: 'goodsName'
                },
                {
                    title: '商品类型',
                    dataIndex: 'goodsType'
                },
                {
                    title: '当前库存量',
                    dataIndex: 'currentInventory'
                },
                {
                    title: '盘点库存量确认',
                    dataIndex: 'num',
                    scopedSlots: {customRender: 'num'}
                }
            ];
            return {
                columns,
                dataSource: [],
                wareHouseList: [],
                warehouseId: '',
                form: this.$form.createForm(this),
                pagination: {
                    showTotal: total => `共 ${total} 条数据`,
                    showSizeChanger: true,
                    showQuickJumper: true,
                    total: 0,
                    current: 1,
                    pageSize: 20
                },
            };
        },
        computed: {
            ...mapGetters(["shopId"]),
            disabled(){
                return !Boolean(this.warehouseId);
            },
        },
        methods: {
            changePage(page) {
                this.pagination.pageSize = page.pageSize;
                this.pagination.current = page.current;
                this.getList();
            },
            // 搜索条件重置
            handleReset() {
                this.form.resetFields();
                this.getList()
            },
            handleSubmit() {
                this.pagination.current = 1;
                this.form.validateFields((err, values) => {
                    this.getList(values)
                });
            },
            //仓库列表
            getWarehouseList() {
                this.$api.storage.getWarehouseList({
                    params: {
                        shopId: this.$store.state.platform.shopId
                    }
                }).then(res => {
                    this.wareHouseList = res;
                });
            },
            //获取页面信息筛选
            getList(searchLimit = {}) {
                // this.$api.storage
                // .warehouseInventory({ params: {warehouseId: warehouseId} })
                // .then(res => {
                //     this.dataSource = res
                //     this.dataSource.forEach(item => {
                //         this.$set(item,'num',item.currentInventory)
                //     })
                // });
                var params = {
                    pageNum: this.pagination.current,
                    pageSize: this.pagination.pageSize,
                };
                Object.assign(params, searchLimit)
                this.$api.storage.warehouseInventoryPost({ body: params })
                    .then(res => {
                        this.dataSource = res.data;
                        this.pagination.total = res.total;
                        this.dataSource.forEach(item => {
                            this.$set(item,'num',item.currentInventory)
                        })
                    });
            },
            // 选择仓库
            changeStock(e) {
                this.warehouseId = e
                this.getList({warehouseId: e})
            },
            // 保存盘点
            submit() {
                let confirmsForm = []
                this.dataSource.forEach(item => {
                    confirmsForm.push(
                        {
                           beforeNum: item.currentInventory,
                           goodsId: item.goodsId,
                           warehouseId: this.warehouseId,
                           num: item.num,
                        }
                    ) 
                })
                this.$api.storage
                .affirm({ body: {confirmsForm: confirmsForm} })
                .then(res => {
                    this.$message.success('操作成功')
                    this.$router.go(-1)
                });
            },
        },
        created() {},
        mounted() {
            this.getWarehouseList()
        },
        watch: {
            'shopId'() {
                this.getWarehouseList()
            },
        }
    };
</script>
<style lang="scss">
    .stock-taking {
        background-color: #fff;
        padding: 24px 32px;
        border-radius: 2px;
        &_title {
            width: 100%;
            height: 40px;
            background: #fffbe6;
            border: 1px solid #ffe58f;
            border-radius: 4px;
            display: flex;
            align-items: center;
            font-size: 14px;
            color: rgba(0, 0, 0, 0.65);
            padding-left: 16px;
            box-sizing: border-box;
        }
        .beforeConfirm,
        .afterConfirm,
        .changed {
            padding-left: 10px;
            &::before {
                content: '';
                background-color: #faad14;
                width: 5px;
                height: 5px;
                border-radius: 5px;
                position: absolute;
                left: 0;
                margin: auto;
                top: 0;
                bottom: 0;
            }
            &.afterConfirm::before {
                background-color: #1890ff;
            }
            &.changed::before {
                background-color: #52c41a;
            }
        }
    }
</style>